import { render, staticRenderFns } from "./number-scale.vue?vue&type=template&id=fe2dbe94&"
import script from "./number-scale.vue?vue&type=script&lang=js&"
export * from "./number-scale.vue?vue&type=script&lang=js&"
import style0 from "./number-scale.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "number-scale.vue"
export default component.exports